import React from 'react'
import { withContext } from '@tools/wr-catalog-base'

import ExportButton from './ExportButton'

export default withContext(ExportButton, {
  mapProps: (context) => ({
    isCatalogExportLoading: context.state.isCatalogExportLoading,
    setCatalogExportLoading: context.actions.setCatalogExportLoading,
    getRegionName: context.utils.getRegionName,
  }),
})
